import { createSlice } from '@metorial/microfrontend';
import { OrganizationRedirect } from './pages/organizationRedirect';
import { ProjectRedirect } from './pages/projectRedirect';
import { ProviderRedirect } from './pages/providerRedirect';
import { RootRedirect } from './pages/rootRedirect';

export let indexSlice = createSlice([
  {
    path: '',
    element: <RootRedirect />
  },
  {
    path: 'p/:organizationId',
    element: <OrganizationRedirect />
  },
  {
    path: 'p/:organizationId/:projectId',
    element: <ProjectRedirect />
  },

  {
    path: 'provider/:providerId',
    element: <ProviderRedirect />
  }
]);
